import '../../components/meetings/meetings';
import Meetings_Component from '../../components/meetings/meetings';

const Meetings = () => {

    return(

        <>

            <Meetings_Component />
        </>
    )
}

export default Meetings;